import { ServiceMaker, methods, services } from "@/services";

export const createTemplateEmail = payload =>
  ServiceMaker(
    `/smsemail/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateEmail = payload =>
  ServiceMaker(
    `/smsemail/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

  export const fetchEditTemplate = id =>
  ServiceMaker(
    `/smsemail/templates/detail/${id}`,
    methods.GET,
    services.master
  ); 

export const fetchTemplateAll = () =>
  ServiceMaker(
    `/smsemail/templates`,
    methods.GET,
    services.master
  );

export const deleteTemplate = (payload) =>
  ServiceMaker(
    `/smsemail/templates/${payload}`,
    methods.DELETE,
    services.master,
    payload
  );

export const concernOptionList = () =>
  ServiceMaker(
    `/smsemail/templates/concern/list`,
    methods.GET,
    services.master
  );